<template>
  <div>
    <b-card>
      <div slot="header">
        {{ $lang.add_content_person }}
      </div>
      <PersonContentFrom
        mode="add"
        :taskId="taskId"
        :isOverlay="isOverlay"
        :showDragFile="true"
        @submit="save"
        @closeModal="closeModal"
        @responseCode="getResponseCode"
      />
    </b-card>
  </div>
</template>
<script>
import PersonContentFrom from "./../forms/personContentFrom";
import { addAttachmentCode } from "@/components/ckeditor/submitAttachment";
export default {
  components: {
    PersonContentFrom,
  },
  inject: ["attachmentTempFinalRepository"],
  props: {
    actionkey: {
      type: String,
      Default: "",
    },
    actionResource: {
      type: String,
      Default: "",
    },
    taskId: {
      type: [String, Number],
      Default: "",
    },
  },
  data() {
    return {
      responseCode: [],
      attachmentId: null,
      isOverlay: false,
      entityId: null,
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    getResponseCode(code) {
      this.responseCode = code;
    },

    async put(payload, allowAddAttachmentCode = true) {
      try {
        const response = await this.personContentRepository.edit(
          this.entityId,
          payload
        );
        this.$notify.success(response.data.message);
      } catch (err) {
        this.$generateError(err);
      }
    },

    async save(payload, allowAddAttachmentCode = true) {
      try {
        this.isOverlay = true;
        let url =
          this.$config.api_url +
          this.$config.resources.person_content_data
            .replace("{resource}", this.actionResource)
            .replace("{key}", this.actionkey);
        const response = await this.$httpService.post(url, payload);
        this.attachmentId = response.data.data;
        this.entityId = response.data.data.id;
        if (this.attachmentId) {
          await this.finalSave();
        }

        if (allowAddAttachmentCode) {
          this.entityId = response.data.data.id;
          let res = await addAttachmentCode(
            "person_content",
            this.entityId,
            payload.description
          );
          if (res.fail_codes) {
            payload.description = res.description;
            await this.put(payload, false);
          }
        }
      } catch (err) {
        this.$generateError(err);
      } finally {
        this.isOverlay = false;
      }
    },

    async finalSave() {
      if (!this.responseCode.length) return;

      try {
        let payload = {
          data: [],
        };
        for (const item of this.responseCode) {
          payload.data.push({
            code: item.code,
            attachment_type_id: 33,
            attachment_type_name: "attachment_type_person_content",
          });
        }
        const actionResource = "person_content";
        const actionKey = this.attachmentId;
        const result = await this.attachmentTempFinalRepository.create(
          payload,
          actionResource,
          actionKey
        );
        this.$notify.success(result.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.closeModal();
      }
    },
  },
};
</script>
